// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from "firebase/functions";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
    apiKey: "AIzaSyAnuHlK5JY2ZSgkmaIeBAARlXNTWdeXi44",
    authDomain: "project-writing-assistant.firebaseapp.com",
    projectId: "project-writing-assistant",
    storageBucket: "project-writing-assistant.appspot.com",
    messagingSenderId: "301795312179",
    appId: "1:301795312179:web:a2e158bb8c1f05e543d946",
    measurementId: "G-K30GR40T1H"
};

const app = initializeApp(firebaseConfig);
let analytics;
if (typeof window !== 'undefined') {
    analytics = getAnalytics(app);
}
initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider("6LdkF7UrAAAAAJOo5bgtp_Ufh23_-w6gybT3SY8z"),
  isTokenAutoRefreshEnabled: true, // refresh automatically
});

const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app); // 👈 this enables Cloud Functions
const provider = new GoogleAuthProvider();

export { auth, db, provider, analytics, functions };
